import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { SwModalframeComponent } from 'src/app/librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { KmsService } from '../../../kms.service';
@Component({
  selector: 'app-model-edit',
  templateUrl: './model-edit.component.html',
  styleUrls: ['./model-edit.component.css']
})
export class ModelEditComponent implements OnInit {
  @ViewChild('modal') modal: SwModalframeComponent;    //弹出层组件
  @Input() param:any;
  @Output() callback = new EventEmitter(); //抛出事件
  // 数据绑定对象
  model: any = {}; 
  // 提交按钮是否禁用
  clickEnable = true; 
  constructor(
    private box: SwMassageBoxService,  //消息提示框
    private kmsService: KmsService,   //请求服务
  ) { }

  ngOnInit() {
    this.clickLoca(this.param["selectedData"]);
  }
  
  clickLoca(selectedData: any) {
    // 查询模型信息
    this.kmsService.queryModelById(selectedData.id).subscribe(
      data => {
        if (data["code"] == '200') {
          this.model = data["data"];
          this.model['isPublic'] = this.model['isPublic'] ? '1' : '0';
        }
      }
    )
  }

  // 保存
  onSubmit({ value, valid }, event: Event) {
    if (valid) {
      let params = JSON.parse(JSON.stringify(this.model));
      params['isPublic'] = parseInt(params['isPublic']);
      this.kmsService.saveOrUpdateModel(params).subscribe(
        data => {
          if(data.code == '200'){
            this.box.success('保存成功！');
            this.modal.toggle();
            this.callback.emit(true);
          }else{
            this.box.waring(data.msg);
          }
        }
      )
    }
  }
}


